import React, {Component} from 'react'
import {Button, Icon, Input} from "antd"
import ModalResults from './ModalResults'
import {retryBatchPrintedFile} from "../../../services/api/3dApi"

class ReGenerateBatch extends Component {
    state = {
        showModal: false,
        error: '',
        loading: false,
        data: [],
        session_id: null,
        value: ''
    }

    closeModal = () => {
        this.setState({
            showModal: false,
        }, () => {
            this._handleClear()
        })
    }

    _handleChangeInput = e => {
        const {value} = e.target

        this.setState({
            value,
            error: ''
        })
    }

    _onSubmit = (e) => {
        e.preventDefault()

        this._getBatchDetailByName()
    }

    _getBatchDetailByName = async (session_id = null) => {
        try {
            this.setState({
                error: '',
                loading: true
            })

            const {value} = this.state

            const payload = {
                batchName: value,
                session_id: session_id || ''
            }

            const {data: response} = await retryBatchPrintedFile(payload)
            const {data, success, error} = response

            if (!success) {
                return this.setState({
                    loading: false,
                    error
                })
            }

            this.setState({
                data,
                session_id: data[0].queue_job.session_id,
                showModal: true,
                loading: false
            })
        } catch (e) {
            this.setState({
                error: e.message,
                loading: false
            })
        }
    }

    _handleClear = () => {
        this.setState({
            showModal: false,
            error: '',
            loading: false,
            data: [],
            value: ''
        })
    }

    _onPaste = () => {

    }

    render() {
        const {showModal, data, loading, error, value, session_id} = this.state

        return (
            <div className="ReGenerateBatch mb-5">
                <div className="d-flex align-items-baseline justify-content-between">
                    <h1 className="PageTitle">Gen lại file in Lô</h1>
                </div>
                <div className="site-layout-background">
                    <form onSubmit={this._onSubmit}>
                        <Input onPaste={this._onPaste} onChange={this._handleChangeInput}
                               style={{fontSize: 40, height: "auto"}}
                               value={value}
                               ref={this._input} placeholder='Nhập lô cần quét'/>
                        {value && <Icon
                            type='close-circle'
                            className="position-absolute cursor-pointer IconInput"
                            onClick={this._handleClear}/>}
                        <div className="d-flex justify-content-between align-items-center">
                            <div>
                                {(error && !session_id) && (
                                    <div className="mt-1 text-danger">{error}</div>
                                )}
                            </div>
                            <Button loading={loading} size="large" type='primary' className='ml-3 mt-3'
                                    onClick={this._onSubmit}
                            >
                                Gen lại file in Lô
                            </Button>
                        </div>
                    </form>
                </div>
                {showModal && (
                    <ModalResults loading={loading} showModal={showModal} closeModal={this.closeModal} data={data}
                                  onRefresh={this._getBatchDetailByName} session_id={session_id} error={error}/>
                )}
            </div>
        )
    }

}

export default ReGenerateBatch
